import 'hammerjs';
import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {AUTHSETTINGS, AUTHSTORAGE} from '@mydocma/auth';
import {APP_CONTAINER_SETTINGS} from '@mydocma/app-container';
import {IMmConfig} from '@docma-mm-core/project/project.interface';
import {ConfigProvider} from '@mydocma/common';
import {MM_CONFIG} from '@docma-mm-core/config/mm.config';
import {TASK_CONFIG, WEBSOCKET_CONFIG as MYDOCMA_WEBSOCKET_CONFIG} from '@mydocma/task';
import {MYDOCMA_SETTINGS_CONFIG} from '../projects/mydocma/mm/src/lib/mydocma-settings/settings-config';
import {SUPPORT_CONFIG} from '@docma-mm-core/ticket/support.config';
import {BIM_CONFIG} from '../projects/mydocma/mm/src/lib/bp-common/config/config';
import {BP_CONFIG} from '@mydocma/co/src/lib/common';
import {LOGGER_CONFIG} from '@mydocma/common/src/lib/logger';
import {REPORTING_CONFIG} from '@docma-mm-core/config/reporting.config';
import {MYDOCMASETTINGS} from '@mydocma/core';
import {EXPORT_CONFIG} from '../projects/mydocma/mm/src/lib/mm-common/config/export-config';
import { PIX_CONFIG, PIX_SETTINGS } from '@mydocma/pix-common';
import { FILE_CONFIG } from '@docma-mm-core/config/file-config';
import { Capacitor } from '@capacitor/core';
import { BrowserDbService } from '@mydocma/common/src/lib/browser-db';
import { BrowserDbService as MmBrowserDbService} from 'projects/mydocma/mm/src/lib/mm-db/browser-db.service';
import { CUSTOM_MAT_ICON_SETTINGS } from '@mydocma/component-library/src/lib/custom-mat-icon';


if (environment.production) {
  enableProdMode();
}


async function main() {

  try {
    // const configProvider = new ConfigProvider(environment,'/assets/configs/config.test_local.json');

    // const configProvider = new ConfigProvider<IMmConfig>(null);
    // const config = await configProvider.loadConfigAsync();
    const configProvider = new ConfigProvider<IMmConfig>(null);
    const config = await configProvider.loadConfigAsync();

    const isNative = Capacitor.getPlatform() !== 'web';
    const authStorage = isNative ? localStorage : sessionStorage;
    await platformBrowserDynamic([

      {provide: LOGGER_CONFIG, useValue: config},
      {provide: FILE_CONFIG, useValue: config.fileConfig},
      {provide: AUTHSETTINGS, useValue: config.authConfig},
      {provide: AUTHSTORAGE, useValue: authStorage},
      {provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig},
      {provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig},
      {provide: MM_CONFIG, useValue: config.mmConfig },
      {provide: REPORTING_CONFIG, useValue: config.reportingConfig },
      {provide: TASK_CONFIG, useValue: config.taskConfig},
      {provide: EXPORT_CONFIG, useValue: config.exportConfig},
      {provide: PIX_CONFIG, useValue: config.pixConfig},
      {provide: PIX_SETTINGS, useValue: config.pixConfig},
      {provide: MYDOCMA_WEBSOCKET_CONFIG, useValue: config.webSocketConfig},
      {provide: MYDOCMA_SETTINGS_CONFIG, useValue: config.settingsConfig},
      {provide: SUPPORT_CONFIG, useValue: config.supportConfig},
      {provide: BIM_CONFIG, useValue: config.bimConfig },
      {provide: BP_CONFIG, useValue: { apiUrl: config.bimConfig.bpApiUrl, parentApp: config.appName }},
      {provide: CUSTOM_MAT_ICON_SETTINGS, useValue: { url: config.matIconsUrl }}

    ]).bootstrapModule(AppModule).then(() => {
      MmBrowserDbService.setDbPrefixName(config.appContainerConfig.dbPrefixName);
      BrowserDbService.setDbPrefixName(config.appContainerConfig.dbPrefixName);
      // if ('serviceWorker' in navigator && environment.production) {
      //   navigator.serviceWorker.register('ngsw-worker.js');
      // }
    });
  } catch (error) {
    // bootstrap entry point — no DI available, Logger cannot be injected here
    console.error(error);
  }
}

main();
